
import React from 'react';
import {VisDiv } from '..';
import {  IoMdCart } from 'react-icons/io';
import { referenceDoc } from '../gestioneDatabase/Docs';
import { GroupedPin } from './GroupedPin';

export const ClientOrderPin = ({clientOrder, item, offer, commonStyle, index, updatedOffer, dataArray}) => {
    const offerFields = offer?.offerFields ? offer?.offerFields : []
    const offerFieldsInPin = !Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>{
      return item?.fieldsIds?.some?.((y)=>y == x?._id)
    })
    const areAllHidden = offerFieldsInPin?.every?.((x)=>x?.hide)
    const isInThisOrder = offerFieldsInPin?.every?.((x)=>x?.clientOrder?._ref == clientOrder?._id)
    const isInOtherOrder = offerFieldsInPin?.every?.((x)=>x?.clientOrder?._ref && x?.clientOrder?._ref != clientOrder?._id)
    const noOrder = offerFieldsInPin?.every?.((x)=>!x?.clientOrder?._ref)
    const addToOrder = () => {
      console.log("ADD TO ORDER", offerFieldsInPin, isInThisOrder, isInOtherOrder, noOrder)
      const updatedData = offerFields?.map?.((item)=>{
        const isInPin = offerFieldsInPin?.some?.((x)=>x?._id == item?._id)
        if(isInPin) {
          const doc = {...item, clientOrder: referenceDoc(clientOrder?._id)}
          console.log("kdcksdncksdjncsdkjnc", doc)
          return (doc)
        }
        return item
      })
      //console.log("updated data", updatedData)
      const updatedOfferDoc = {...offer, offerFields: updatedData}
      updatedOffer(updatedOfferDoc)
    }
    const removeFromOrder = () => {
      console.log("REMOVE FROM ORDER", offerFieldsInPin)
      const updatedData = offerFields?.map?.((item)=>{
        const isInPin = offerFieldsInPin?.some?.((x)=>x?._id == item?._id)
        if(isInPin) {
          const doc = {...item, clientOrder: undefined}
          console.log("lqqlruch", doc)
          return (doc)
        }
        return item
      })
      //console.log("updated data", updatedData)
      const updatedOfferDoc = {...offer, offerFields: updatedData}
      updatedOffer(updatedOfferDoc)
    }
  
    const noOrderColour =  index % 2 ? "white":"#f3f4f3"
    const orderColor =  index % 2 ? "#BDF5BD":"#E9FCE9"
    const backgroundColor = isInThisOrder ? orderColor : noOrderColour
  
  
     if(isInOtherOrder || areAllHidden) {
      return null
     }
  
     if(!clientOrder) return null
    return(            
    <VisDiv>
        <VisDiv style={{backgroundColor: backgroundColor}}>
          <GroupedPin 
            customBackgroundColour={backgroundColor}
            products={dataArray} 
            offer={offer} 
            item={item} 
            commonStyle={commonStyle} 
  
          />
        </VisDiv>
      <VisDiv style={{display:"flex", justifyContent:"left", marginTop:"-30px", width: "300px", padding:"3px", borderRadius:"10px"}}> 
          <VisDiv rules={[noOrder]} className='round-back-button' style={{backgroundColor:"grey"}}  onClick={(e) => {addToOrder()}}>
            <IoMdCart fontSize={20} color='white'/>
          </VisDiv>
          <VisDiv rules={[isInThisOrder]} className='round-back-button' style={{backgroundColor:"green"}} onClick={(e) => {removeFromOrder()}}>
            <IoMdCart fontSize={20} color='white' />
          </VisDiv>
      </VisDiv>
    </VisDiv>
    )
    }
